import usePersistUser from '@modules/core/hooks/usePersistUser';
import { IS_UAE_ENV } from '@modules/core/utils';
import { USER_ROLE } from '@modules/identity/api/const';
import { Navigate } from '@tanstack/react-router';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';

const HomePage = () => {
  const { user } = usePersistUser();
  const { isFeatureActive, isFeatureFlagsLoading } = useFeatureFlags();

  // While loading roles
  if (!user?.roles) {
    return <></>;
  }
  if (isFeatureFlagsLoading) return <></>;

  // Redirect to dashboard if UAE and brokerManager
  // and has feature flag
  if (
    IS_UAE_ENV
    && user.roles.includes(USER_ROLE.manager)
    && isFeatureActive('dashboards.module')
  ) {
    return <Navigate to='/dashboard' />;
  }

  // Default redirection
  return <Navigate to='/clients' />;
};

export default HomePage;
